export default {
    state: {
        echartData: {
            itemId: 0,
            option: "",
            position: {
                left: 0,
                top: 0,
                width: 0,
                height: 0,
                pageMt: 1,
                shapetMt: 1,
            },
        },
        echartList: [],
        slideEchartList: [],
        sharePageEchartList: [],
    },
    getters: {},
    mutations: {
        setFloatEChartState(state, obj) {
            state.echartList = obj;
        },
        setSlideEChartState(state, payload) {
            const { data, index } = payload;
            let newData = new Array(index + 1).fill([]);
            state.slideEchartList = newData;
            state.slideEchartList.splice(index, 1, data);
        },
        setShareEChartState(state, payload) {
            state.sharePageEchartList = payload;
        },
        cleanSlideEChartState(state, payload) {
            state.slideEchartList = [];
        },
    },
};
